<footer>
    <div class="row" style="padding-bottom: 25px;">
        <div class="col-md-4 offset-md-2" style="text-align: center">
            <a><img alt="NC DOC Logo" class="center-block img-responsive" height="50px;" src="../../../assets/images/NCBOLD.png" ></a>
        </div>
        <div class="col-md-6 smaller">
            Business/Privilege Licenses:  <a href="tel: 18002288443">1.800.228.8443</a><br>
            Occupational Licenses:  <a href="tel: 19197071500">1.919.707.1500</a><br>  
            Need help or have questions? <a class="link-bold" href="https://edpnc.com/start-or-grow-a-business/start-a-business/contact-blnc/" target="_top">Contact EDPNC Small Business Advisors.</a>
       </div>
    </div>
</footer> 
